module.exports = __webpack_public_path__ + "media/images/logo-iq-mark-9dfcb5d6.svg";